const o = (c, e) => {
  const r = (() => {
    try {
      return new URL(e), !0;
    } catch {
      return !1;
    }
  })();
  let n = `url(${c})`;
  r && (n += `, url(${e})`);
  const a = {
    backgroundImage: n,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover"
  };
  return r || (a.backgroundColor = e), a;
};
export {
  o as overlayedBackground
};
